import React, { ReactNode, useState } from 'react';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

interface AccordionComponentsProps {
  className?: string;
  title?: string;
  subtitle?: string;
}

export default function AccordionComponentsTitle(props: AccordionComponentsProps) {
  const { title, subtitle } = props;
  const { t } = useTranslation();

  return (
    <Box className="summary-text-container">
      <Typography className="text-container-title">{t(`${title}`)}</Typography>
      {subtitle !== undefined && <Typography className="text-container-details">{t(`${subtitle}`)}</Typography>}
    </Box>
  );
}
